import * as Storage from "../lib/Storage.ts";

var
  //not starting by than will be ignored, first will be the default one
  acceptableLocales = ['en','fr','de','es','pt','it','nl','ja','ru','sq','ko','sv','key'],
  //default
  currentLanguage = acceptableLocales[0],

  //long names, no need to translate for now (each name is in its own language)
  names = {
    'en' : 'English',
    'en-us' : 'English (US)',
    'en-gb' : 'English (UK)',
    'en-au' : 'English (AU)',
    'en-ca' : 'English (CA)',
    'en-za' : 'English (ZA)',
    'en-sg' : 'English (SG)',
    'fr-fr' : 'Français',
    'fr-be' : 'Français (Belgique)',
    'fr-ch' : 'Français (Suisse)',
    'nl-nl' : 'Dutch',
    'nl-be' : 'Dutch (België)',
    'de-de' : 'Deutsch',
    'de-at' : 'Deutsch (Österreich)',
    'de-ch' : 'Deutsch (Schweiz)',
    'es-es' : 'Español',
    'it-it': 'Italiano',
    'ko-kr' : '한국어',
    'sv-se' : 'Svenska',
    'pt-pt': 'Português',
    'pt-br': 'Português (BR)',
    'ru-ru': 'русский',
    'sq': 'Shqip',
    'ja-jp': '日本'
  },
  selectableLocales = Object.keys(names);

function normalize(newLanguage :string){
  var items = newLanguage.split(/-|_/g);
  items[0] = items[0].toLowerCase();
  if(items.length>1){
    items[1] = items[1].toUpperCase();
  }
  return items;
}
//set the language, return true if it changed something
function _set(newLanguage :string){
  if(!newLanguage){
    return false;
  }
  var items = normalize(newLanguage);
  newLanguage = items.join('-').toLowerCase();
  if(acceptableLocales.indexOf(newLanguage)===-1 && acceptableLocales.indexOf(items[0])===-1){
    return false;
  }
  if(currentLanguage.indexOf(newLanguage)===0){
    //do nothing we have a closer locale (with country code) than new one
    return false;
  }else{
    currentLanguage = newLanguage;
  }
  return true;
}
function updateDom(){
  try{
    document.body.parentElement.setAttribute("lang" ,currentLanguage);
    const uses12hClock = new Intl.DateTimeFormat(currentLanguage, {hour: 'numeric'})
      .formatToParts(new Date())
      .some(p => p.type === 'dayPeriod');
    document.body.classList.toggle('has-ampm',uses12hClock)
  }catch(e){
    console.log(e);
  }
}
export function get(){
  return currentLanguage;
}
//use browser to set language
_set(navigator.language);
if(navigator.languages){
  for(let i=navigator.languages.length-1;i>=0;i--){
    _set(navigator.languages[i]);
  }
}
//use sessionStorage to set language
_set( Storage.sessionGet('lang'));
updateDom();


export function set(lang :string){
  if(!lang) return get();
  try{
    normalize(lang);
  }catch(e){
    console.log('Error with locale '+lang,e);
  }
  if(_set(lang)){
    Storage.sessionSet('lang',get());
    updateDom();
  }
  return get();
}
export function locales(){
  var res = [];
  for(let i=0;i<selectableLocales.length;i++){
    let id = selectableLocales[i];
    res.push({id,text:names[id],selected:id===currentLanguage});
  }
  return res;
}
